// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
  min-height: 0;
}

.information-layout {
  display: grid;
  gap: 0.75rem;
  grid-template-columns: minmax(0, 1.45fr) minmax(390px, 0.85fr);
  height: 100%;
  min-height: 0;
}

.information-card {
  background: #fff;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(19, 42, 70, 0.08);
  min-height: 0;
  overflow: hidden;
}

.card-heading {
  align-items: center;
  background: #1f4e78;
  color: #fff;
  display: flex;
  height: auto !important;
  justify-content: space-between;
  margin: 0 !important;
  max-width: none !important;
  min-height: 54px !important;
  padding: 0.65rem 0.9rem;
  width: auto !important;
}

.card-heading::before,
.card-heading::after {
  content: none !important;
  display: none !important;
}

h2 {
  color: #fff !important;
  font-size: 1rem;
  margin: 0;
}

p {
  color: #d7e7f4;
  font-size: 0.72rem;
  margin: 0.1rem 0 0;
}

.save-state {
  font-size: 0.72rem;
}

.save-state span {
  color: #4ade80;
}

.heading-actions { align-items: center; display: flex; gap: 0.65rem; }
.clean-form-button { background: transparent; border: 1px solid #b9cee0; border-radius: 4px; color: #fff; cursor: pointer; font-size: 0.7rem; font-weight: 700; min-height: 31px; min-width: 78px; padding: 0.3rem 0.85rem; }
.clean-form-button:hover { background: #fff; color: #9b1c35; }

.form-grid {
  display: grid;
  gap: clamp(0.55rem, 1.4vh, 0.9rem) 0.75rem;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  padding: clamp(0.75rem, 2vh, 1.2rem);
}

label {
  display: grid;
  gap: 0.25rem;
  margin: 0;
  min-width: 0;
}

label > span,
legend {
  color: #354a5f;
  font-size: 0.72rem;
  font-weight: 700;
}

input,
select {
  background: #fff;
  border: 1px solid #b8c2ce;
  border-radius: 4px;
  font: inherit;
  height: 38px;
  min-width: 0;
  padding: 0.4rem 0.55rem;
  width: 100%;
}

input:focus,
select:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.15);
  outline: none;
}

.editable-select {
  position: relative;
}

.editable-select button {
  align-items: center;
  background: transparent;
  border: 0;
  cursor: pointer;
  display: flex;
  height: 100%;
  justify-content: center;
  padding: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 34px;
}

.editable-select button::after {
  border-bottom: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid #53687b;
  content: "";
}

.editable-select input {
  padding-right: 2rem;
}

.editable-select input::-webkit-calendar-picker-indicator {
  display: none !important;
}

.wide-field {
  grid-column: span 2;
}

.working-hours {
  border: 1px solid #d7dde5;
  border-radius: 6px;
  display: grid;
  gap: 0.5rem;
  grid-column: span 3;
  grid-template-columns: repeat(3, 1fr);
  margin: 0;
  padding: 0.55rem 0.7rem 0.7rem;
}

legend {
  padding: 0 0.25rem;
  width: auto;
}

@media (max-width: 1050px) {
  .information-layout {
    grid-template-columns: minmax(0, 1.2fr) minmax(340px, 0.8fr);
  }

  .form-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .working-hours {
    grid-column: span 2;
  }
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/lab-audit-checklist/tabs/information-tab/information-tab.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,8DAA8D;EAC9D,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;EAEE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB,mBAAmB,EAAE,aAAa,EAAE,YAAY,EAAE;AACrE,qBAAqB,uBAAuB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,WAAW,EAAE,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,eAAe,EAAE,uBAAuB,EAAE;AAC5N,2BAA2B,gBAAgB,EAAE,cAAc,EAAE;;AAE7D;EACE,aAAa;EACb,0CAA0C;EAC1C,gDAAgD;EAChD,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAS;EACT,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;;EAEE,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,qCAAqC;EACrC,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;IACE,4DAA4D;EAC9D;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[":host {\n  display: block;\n  height: 100%;\n  min-height: 0;\n}\n\n.information-layout {\n  display: grid;\n  gap: 0.75rem;\n  grid-template-columns: minmax(0, 1.45fr) minmax(390px, 0.85fr);\n  height: 100%;\n  min-height: 0;\n}\n\n.information-card {\n  background: #fff;\n  border: 1px solid #d9dee7;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(19, 42, 70, 0.08);\n  min-height: 0;\n  overflow: hidden;\n}\n\n.card-heading {\n  align-items: center;\n  background: #1f4e78;\n  color: #fff;\n  display: flex;\n  height: auto !important;\n  justify-content: space-between;\n  margin: 0 !important;\n  max-width: none !important;\n  min-height: 54px !important;\n  padding: 0.65rem 0.9rem;\n  width: auto !important;\n}\n\n.card-heading::before,\n.card-heading::after {\n  content: none !important;\n  display: none !important;\n}\n\nh2 {\n  color: #fff !important;\n  font-size: 1rem;\n  margin: 0;\n}\n\np {\n  color: #d7e7f4;\n  font-size: 0.72rem;\n  margin: 0.1rem 0 0;\n}\n\n.save-state {\n  font-size: 0.72rem;\n}\n\n.save-state span {\n  color: #4ade80;\n}\n\n.heading-actions { align-items: center; display: flex; gap: 0.65rem; }\n.clean-form-button { background: transparent; border: 1px solid #b9cee0; border-radius: 4px; color: #fff; cursor: pointer; font-size: 0.7rem; font-weight: 700; min-height: 31px; min-width: 78px; padding: 0.3rem 0.85rem; }\n.clean-form-button:hover { background: #fff; color: #9b1c35; }\n\n.form-grid {\n  display: grid;\n  gap: clamp(0.55rem, 1.4vh, 0.9rem) 0.75rem;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  padding: clamp(0.75rem, 2vh, 1.2rem);\n}\n\nlabel {\n  display: grid;\n  gap: 0.25rem;\n  margin: 0;\n  min-width: 0;\n}\n\nlabel > span,\nlegend {\n  color: #354a5f;\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\ninput,\nselect {\n  background: #fff;\n  border: 1px solid #b8c2ce;\n  border-radius: 4px;\n  font: inherit;\n  height: 38px;\n  min-width: 0;\n  padding: 0.4rem 0.55rem;\n  width: 100%;\n}\n\ninput:focus,\nselect:focus {\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.15);\n  outline: none;\n}\n\n.editable-select {\n  position: relative;\n}\n\n.editable-select button {\n  align-items: center;\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  padding: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 34px;\n}\n\n.editable-select button::after {\n  border-bottom: 0;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 5px solid #53687b;\n  content: \"\";\n}\n\n.editable-select input {\n  padding-right: 2rem;\n}\n\n.editable-select input::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n.wide-field {\n  grid-column: span 2;\n}\n\n.working-hours {\n  border: 1px solid #d7dde5;\n  border-radius: 6px;\n  display: grid;\n  gap: 0.5rem;\n  grid-column: span 3;\n  grid-template-columns: repeat(3, 1fr);\n  margin: 0;\n  padding: 0.55rem 0.7rem 0.7rem;\n}\n\nlegend {\n  padding: 0 0.25rem;\n  width: auto;\n}\n\n@media (max-width: 1050px) {\n  .information-layout {\n    grid-template-columns: minmax(0, 1.2fr) minmax(340px, 0.8fr);\n  }\n\n  .form-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .working-hours {\n    grid-column: span 2;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
